export const normalizeRole = (value: string) => {
  return (value || '')
    .toString()
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
};

export const getRankScore = (rankOrDesignation: string) => {
  const v = normalizeRole(rankOrDesignation);
  if (!v) return 999;

  const priority = [
    'president',
    'adl president',
    'senior vice president',
    'vice president',
    'general secretary',
    'secretary',
    'joint secretary',
    'special officer',
    'media co-ordinator',
    'legal advisor',
    'it incharge',
    'awareness co-ordinator',
    'cyber security officer',
    'fire safety trainer',
    'self defense trainer',
    'executive member',
    'senior advisor',
    'advisor',
    'life time member',
    'lifetime member',
    'member'
  ];

  // Exact match first
  const exactIdx = priority.indexOf(v);
  if (exactIdx !== -1) return exactIdx;

  // Handle prefixed titles like "National Life Time Member", "District President", etc.
  // Find the best (lowest index) priority phrase that appears in the string.
  let best = 999;
  for (let i = 0; i < priority.length; i += 1) {
    const p = priority[i];
    if (v.includes(p)) {
      best = i;
      break;
    }
  }

  return best;
};

export const getEffectiveRoleForSorting = (rank: string, designation: string) => {
  const r = (rank || '').toString();
  const d = (designation || '').toString();

  const rn = normalizeRole(r);
  const dn = normalizeRole(d);

  // If rank is missing or generic, always prefer designation
  if (!rn || rn === 'member') {
    return d;
  }

  // If designation exists and is higher priority than rank, prefer designation
  if (dn) {
    const rankScore = getRankScore(r);
    const desigScore = getRankScore(d);
    if (desigScore < rankScore) {
      return d;
    }
  }

  return r;
};
